/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ChecklistElementType } from '@gh/builder-shared-data';
import {
  AbstractSnapshotFormComponent,
  EnumDictionary,
  FormState,
  FormStateBuilder,
  FormStateSnapshot,
  getRouteInitData,
  whenCreateOrEditMode,
} from '@gh/common-shared';
import { assign } from 'lodash';
import { ChklSection, ChklSectionInfo } from '../../../resources/checklists.model';
import { ChecklistsBusinessService } from '../../../resources';
import { NotificationService } from '@gh/core-ui';

@Component({
  standalone: false,
             selector: 'gh-checklists-detail-elements',
             templateUrl: 'checklists-detail-elements.component.html',
             changeDetection: ChangeDetectionStrategy.OnPush,
           })
export class ChecklistsDetailElementsComponent extends AbstractSnapshotFormComponent<ChklSectionInfo> implements OnInit, OnChanges {
  
  @Input() isParent: boolean;
  @Input() notEditable: boolean;
  @Input() handleError: boolean;
  @Output() typeChange = new EventEmitter<any>();
  elementTypeDict: EnumDictionary<ChecklistElementType>;
  init: any;
  maxCountOfSignature: number = 5;
  constructor(
              private businessService: ChecklistsBusinessService,
              private route: ActivatedRoute,
              private notifications: NotificationService,
              private formStateBuilder: FormStateBuilder) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.init = getRouteInitData(this.route);
    assign(this, this.init);
  }

  ngOnChanges(changes: SimpleChanges): void {
    super.ngOnChanges(changes);
    if (this.handleError) {
      this.form.group.markAllAsTouched();
    }
  }

  onTypeChanges(event: any): void {
    if (event.value === ChecklistElementType.Signature) {
      const countOfSignatures = this.init?.details?.checklistElements
        ?.filter((item: ChklSection) => item.info.value.elementType === ChecklistElementType.Signature)?.length;
      if (countOfSignatures > this.maxCountOfSignature) {
        this.notifications.error('msg_max_signature_allowed');
        this.form.getControl('elementType').setErrors([]);
      }
    }
    this.typeChange.emit(event.value);
  }

  protected buildForm(snapshot: FormStateSnapshot<ChklSectionInfo>): FormState<ChklSectionInfo> {
    return this.formStateBuilder.buildPlain({
      mode: this.mode,
      enabled: whenCreateOrEditMode(),
      snapshot,
      children: {
        elementType: { required: true },
        title: { required: true },
      },
    });
  }
}
